// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
export default function escapeSpecialCharacters(string) {
	return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
}
